import api from '../../lib/api';
import { url_api_v1_overview_kit_get, url_api_v1_overview_kit_doc_add, url_api_v1_overview_kit_doc_remove } from '../../lib/apiUrl';
import { isUndefinedNullEmpty } from '../submission_boards/component/SbModel';
import { OverviewKitDocumentModel } from '../submission_kits/components/KitModels';

class OverviewKitService {
  getOverviewKitDocuments = async (user_uuid:string) => {
    try {
      const url = url_api_v1_overview_kit_get;
      let queryFilter = '';
      if(!isUndefinedNullEmpty(user_uuid)) {
          queryFilter += (queryFilter == '' ? '?' : '&') + 'user_uuid=' + user_uuid;
      }
      const response = await api.get(url + queryFilter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in getting overview kit documents.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  addInOverviewKitDocument = async (kit_id: any, tag: string, position: number) => {
    try {
      const url = url_api_v1_overview_kit_doc_add;
      const response = await api.post(url, {
        kit_document_id: kit_id,
        tag: tag,
        position: position
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in adding media in overview kit.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  
  deleteFromOverviewKitDocument = async (overviewKitDocument: OverviewKitDocumentModel) => {
    try {
      const url = url_api_v1_overview_kit_doc_remove;
      const response = await api.post(url, {
        id: overviewKitDocument.id,
        kit_document_id: overviewKitDocument.kit_document_id,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error removing media from overview kit.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };

  
}

const overviewKitService = new OverviewKitService();

export default overviewKitService;

